import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-site-manager-buddy',
  templateUrl: './site-manager-buddy.component.html',
  styleUrls: ['./site-manager-buddy.component.scss']
})
export class SiteManagerBuddyComponent implements OnInit {
  public pcCode: any = '';
  result: any = [];
  costCenters: any = [];

  constructor(
    private dashboardService: DashboardService,
    private notifyService: NotificationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  moveToQuery(): void {
    this.router.navigateByUrl('/queries/create/1/79');
  }
  searchProfitCenter(): void {
    if (this.pcCode == '') {
      Swal.fire('Please Enter Code !', '', 'error');
      return;
    } else {
      const params = {
        pc_code : this.pcCode
      };
      console.log(params);
      this.dashboardService.getPCByCode(params).subscribe( res => {
        this.result = res;
        if (this.result.status) {
            // this.notifyService.showSuccess(this.result.msg, 'Success');
            this.costCenters = this.result.data;
        } else {
            this.notifyService.showError(this.result.msg, 'Error');
            this.costCenters = [];
        }
      }, err => {
             this.notifyService.showError('Internal Server Error', 'Error');
      });
    }

  }

}
